import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "capitalizeFirst",
})
export class CapitalizeFirstPipe implements PipeTransform {
  transform(input: string): string {
    return input.charAt(0).toUpperCase() + input.slice(1);
  }
}
